// common.js
// const backendDomain = "http://192.168.1.128/sri_danth";
const backendDomain = "https://sridanth.oakyaitservices.in/api";

const BEARER_TOKEN = "Bearer sri_danth_916";

const SummaryApi = {
  backendDomain: backendDomain,
  bearerToken: BEARER_TOKEN,

  // Admin APIs
  adminLogin: {
    url: `${backendDomain}/admin/admin_login.php`,
    method: "POST",
  },

  // Product APIs
  product: {
    getAll: {
      url: `${backendDomain}/product/product_admin_retrieve.php`,
      method: "GET",
    },
    create: {
      url: `${backendDomain}/product/product_create.php`,
      method: "POST",
    },
    update: {
      url: `${backendDomain}/product/product_update.php`,
      method: "POST",
    },
    delete: {
      url: `${backendDomain}/product/product_delete.php`,
      method: "POST",
    },
    getById: {
      url: `${backendDomain}/product/product_admin_retrieve.php`,
      method: "GET",
    },
    productRetrieveApi: {
      url: `${backendDomain}/product/product_retrieve.php`,
      method: "GET",
    },
    productDetails: {
      url: `${backendDomain}/product/product_retrieve.php`,
      method: "POST",
    },
  },

  // Customer APIs
  allUser: {
    url: `${backendDomain}/customer/customer_admin_retrieve.php`,
    method: "GET",
  },
  customerLogin: {
    url: `${backendDomain}/customer/customer_login.php`,
    method: "POST"
  },
  customerDetailsById: {
    url: `${backendDomain}/customer/customer_retrieve.php`,
    method: "POST"
  },
  customerRegister: {
    url: `${backendDomain}/customer/customer_create.php`,
    method: "POST",
  },
   customerOtp: {
    url: `${backendDomain}/customer/customer_otp.php`,
    method: "POST",
  },
  customerVerifyOtp: {
    url: `${backendDomain}/customer/customer_otp.php`,
    method: "PUT",
  },
  customerUpdate:{
    url: `${backendDomain}/customer/customer_update.php`,
    method: "POST",
  },
createAddress:{
     url: `${backendDomain}/address/address_create.php`,
    method: "POST", 
},
getAddressById:{
      url: `${backendDomain}/address/address_retrieve.php`,
    method: "POST",  
},
  // Cart APIs
  addToCart: {
    url: `${backendDomain}/cart/cart_create.php`,
    method: "POST"
  },
  getCartCount: {
    url: `${backendDomain}/cart/cart_count.php`,
    method: "POST"
  },
  getCartItems: {
    url: `${backendDomain}/cart/cart_retrieve.php`,
    method: "POST"
  },
  updateCartItem: {
    url: `${backendDomain}/cart/cart_update.php`,
    method: "POST"
  },
  removeCartItem: {
    url: `${backendDomain}/cart/cart_delete.php`,
    method: "DELETE"
  },
  clearCart: {
    url: `${backendDomain}/cart/cart_clear.php`,
    method: "POST"
  },

  // Order APIs
  allOrder: {
    url: `${backendDomain}/orderdetails/order_retrieve.php`,
    method: "GET",
  },
  orderDetailsByOrderID: {
    url: `${backendDomain}/orderdetails/order_retrieve.php`,
    method: "POST",
  },
  editOrderStatus: {
    url: `${backendDomain}/orderdetails/order_status_update.php`,
    method: "POST",
  },
  order: {
    get: {
      url: `${backendDomain}/orderdetails/order_retrieve.php`,
      method: "GET",
    },
    getById: {
      url: `${backendDomain}/orderdetails/order_retrieve.php`,
      method: "POST",
    },
    update: {
      url: `${backendDomain}/orderdetails/order_update.php`,
      method: "POST",
    },
    create: {
      url: `${backendDomain}/orderdetails/order_create.php`,
      method: "POST"
    }
  },

  // Product Image Base URL
  productImage: {
    url: `${backendDomain}/product/`,
  },
  
  // Category APIs
  getAllCategories: {
    url: `${backendDomain}/category/category_retrieve.php`,
    method: "GET"
  },
  
  // Brand APIs
  getAllBrands: {
    url: `${backendDomain}/brand/brand_retrieve.php`,
    method: "GET"
  },
  
  // Wishlist APIs (if needed)
  addToWishlist: {
    url: `${backendDomain}/wishlist/wishlist_create.php`,
    method: "POST"
  },
  
  // Address APIs (if needed)
  addAddress: {
    url: `${backendDomain}/address/address_create.php`,
    method: "POST"
  },
  updateAddress:{
    url: `${backendDomain}/address/address_create.php`,
    method: "POST"
  },
  
  // Payment APIs (if needed)
  createPayment: {
    url: `${backendDomain}/address/address_update.php`,
    method: "PUT"
  },
  
  // Review APIs (if needed)
  addReview: {
    url: `${backendDomain}/review/review_create.php`,
    method: "POST"
  }
};

export default SummaryApi;